// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gm_wzh {
  flex: 1;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.avEEGx {
  display: flex;
  flex-grow: 2;
  flex-direction: column;
  gap: var(--spacing-2, 16px);
  overflow-y: auto;
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
}

.v9oXsY {
  padding: var(--spacing-3, 24px) 0 0;
  display: flex;
  flex-direction: row;
  gap: var(--spacing-2, 16px);
}

.o1x9Yq {
  flex: 1;
}

.cioI2N {
  padding: var(--spacing-1-5);
}

.OXhxIL {
  border-radius: var(--spacing-0-5);
  padding: var(--spacing-2);
  border: 1px solid var(--stroke-neutral-subtle, #f2f2f2);
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  gap: var(--spacing-1);
}

.TzErL8 {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: var(--text-neutral-dark, #1f1f1f);
}

.kKEh9J {
  font-size: var(--font-size-md, 14px);
  line-height: var(--line-height-180);
  font-weight: var(--font-weight-regular, 400);
}

.VNEQUY {
  font-size: var(--font-size-lg, 16px);
  line-height: var(--line-height-180);
  font-weight: var(--font-weight-semibold, 600);
}

.TdtTGK {
  font-size: var(--font-size-sm, 12px);
  font-weight: var(--font-weight-regular, 400);
  color: var(--text-neutral-stronger, #666666);
}

.r3MQjR {
  gap: var(--spacing-1-5);
  display: flex;
  flex-direction: column;
  font-size: var(--font-size-md, 14px);
  font-weight: var(--font-weight-regular, 400);
}

.mbNOKI {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-size: var(--font-size-lg, 16px);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark, #1a1a1a);
}

.BQisB9 {
  margin-bottom: 2px;
}

.A3S5D1 {
  gap: var(--spacing-1);
  display: flex;
}

.yycyCp {
  cursor: default;
}

.OblwUf {
  cursor: pointer;
  text-decoration: underline;
  color: var(--link-default);
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-layout/src/layouts/DrawerOperator/pages/RegisterForm/RegisterForm.module.css"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;EAChB,iEAAiE;AACnE;;AAEA;EACE,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,uDAAuD;EACvD,iEAAiE;EACjE,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;EACpC,4CAA4C;EAC5C,4CAA4C;AAC9C;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,iEAAiE;EACjE,oCAAoC;EACpC,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;AAC5B","sourcesContent":[".container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n}\n\n.info {\n  display: flex;\n  flex-grow: 2;\n  flex-direction: column;\n  gap: var(--spacing-2, 16px);\n  overflow-y: auto;\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n}\n\n.footer {\n  padding: var(--spacing-3, 24px) 0 0;\n  display: flex;\n  flex-direction: row;\n  gap: var(--spacing-2, 16px);\n}\n\n.button {\n  flex: 1;\n}\n\n.input {\n  padding: var(--spacing-1-5);\n}\n\n.card {\n  border-radius: var(--spacing-0-5);\n  padding: var(--spacing-2);\n  border: 1px solid var(--stroke-neutral-subtle, #f2f2f2);\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  gap: var(--spacing-1);\n}\n\n.cardHeader {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.cardProfile {\n  font-size: var(--font-size-md, 14px);\n  line-height: var(--line-height-180);\n  font-weight: var(--font-weight-regular, 400);\n}\n\n.cardOperator {\n  font-size: var(--font-size-lg, 16px);\n  line-height: var(--line-height-180);\n  font-weight: var(--font-weight-semibold, 600);\n}\n\n.cardDesc {\n  font-size: var(--font-size-sm, 12px);\n  font-weight: var(--font-weight-regular, 400);\n  color: var(--text-neutral-stronger, #666666);\n}\n\n.form {\n  gap: var(--spacing-1-5);\n  display: flex;\n  flex-direction: column;\n  font-size: var(--font-size-md, 14px);\n  font-weight: var(--font-weight-regular, 400);\n}\n\n.formTitle {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-size: var(--font-size-lg, 16px);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark, #1a1a1a);\n}\n\n.formLabel {\n  margin-bottom: 2px;\n}\n\n.termsWrapper {\n  gap: var(--spacing-1);\n  display: flex;\n}\n\n.termsText {\n  cursor: default;\n}\n\n.link {\n  cursor: pointer;\n  text-decoration: underline;\n  color: var(--link-default);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `gm_wzh`,
	"info": `avEEGx`,
	"footer": `v9oXsY`,
	"button": `o1x9Yq`,
	"input": `cioI2N`,
	"card": `OXhxIL`,
	"cardHeader": `TzErL8`,
	"cardProfile": `kKEh9J`,
	"cardOperator": `VNEQUY`,
	"cardDesc": `TdtTGK`,
	"form": `r3MQjR`,
	"formTitle": `mbNOKI`,
	"formLabel": `BQisB9`,
	"termsWrapper": `A3S5D1`,
	"termsText": `yycyCp`,
	"link": `OblwUf`
};
module.exports = ___CSS_LOADER_EXPORT___;
